import Link from "@mui/material/Link";

import { colors } from "@dotnet/telematics-design-system";

import { svgFontSize } from "shared";

import { useStyleOptions } from "./hooks";
import { CombinedTextLinkProps, TEXT_LINK_COLORS } from "./types";

const TextLink = ({
    children,
    size,
    color = TEXT_LINK_COLORS.Primary,
    icon,
    isDisabled,
    ...props
}: CombinedTextLinkProps) => {
    const { textDisabled } = colors;

    const styleOptions = useStyleOptions(color);

    const colorDefault = isDisabled ? textDisabled : styleOptions.color.default;

    const colorHover = styleOptions.color.hover;
    const colorActive = styleOptions.color.active;
    const fontSize = styleOptions.fontSize[size];
    const lineHeight = styleOptions.lineHeight[size];
    const letterSpacing = styleOptions.letterSpacing[size];

    return (
        <Link
            {...props}
            rel="noreferrer"
            underline="none"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "500",
                color: colorDefault,
                textDecorationColor: "inherit",
                pointerEvents: isDisabled ? "none" : "auto",
                fontSize,
                lineHeight,
                letterSpacing,
                transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

                "& > svg": {
                    marginLeft: "2px",
                    ...svgFontSize(16)
                },

                "&:hover": {
                    color: colorHover
                },

                "&:active": {
                    color: colorActive
                }
            }}
        >
            {children}

            {icon}
        </Link>
    );
};

export { TEXT_LINK_SIZES } from "./types";

export default TextLink;
